export const SET_SWIPER_STATE = 'SET_SWIPER_STATE';
export const GO_NEXT = 'GO_NEXT';
export const GO_PREV = 'GO_PREV';
export const GO_TO_BLOCK = 'GO_TO_BLOCK';
export const COMPLETE_FORM = 'COMPLETE_FORM';
export const SET_FIELD_ANSWER = 'SET_FIELD_ANSWER';
export const INSERT_EMPTY_FIELD_ANSWER = 'INSERT_EMPTY_FIELD_ANSWER';
export const RESET_ANSWERS = 'RESET_ANSWERS';
export const SET_IS_FIELD_VALID = 'SET_IS_FIELD_VALID';
export const SET_IS_FIELD_ANSWERED = 'SET_IS_FIELD_ANSWERED';
export const SET_IS_FIELD_PENDING = 'SET_IS_FIELD_PENDING';
export const SET_FIELD_PENDING_MSG = 'SET_FIELD_PENDING_MSG';
export const SET_FIELD_VALIDATION_ERR = 'SET_FIELD_VALIDATION_ERR';
export const SET_IS_FIELD_ANSWER_CORRECT = 'SET_IS_FIELD_ANSWER_CORRECT';
export const SET_IS_FIELD_ANSWER_LOCKED = 'SET_IS_FIELD_ANSWER_LOCKED';
export const SET_IS_CURRENT_BLOCK_SAFE_TO_SWIPE =
	'SET_IS_CURRENT_BLOCK_SAFE_TO_SWIPE';
export const SET_THANKYOU_SCREENS = 'SET_THANKYOU_SCREENS';
export const SET_IS_FIELD_CORRECT_INCORRECT_SCREEN_DISPLAYED = 'SET_IS_FIELD_CORRECT_INCORRECT_SCREEN_DISPLAYED';
export const SET_CORRECT_INCORRECT_DISPLAY = 'SET_CORRECT_INCORRECT_DISPLAY';
export const SET_IS_REVIEWING = 'SET_IS_REVIEWING';
export const SET_SUBMISSION_ERR = 'SET_SUBMISSION_ERR';
export const SET_IS_SUBMITTING = 'SET_IS_SUBMITTING';
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA';
export const SET_IS_FOCUSED = 'SET_IS_FOCUSED';
export const SET_FOOTER_DISPLAY = 'SET_FOOTER_DISPLAY';
export const STORE_KEY = 'quillForms/renderer-core';
